const domain: string = 'ASSURANCE'

export const SAVE_ASSURANCE: string = `${domain}/SAVE_ASSURANCE`